import React from "react";
import styled, { css } from "styled-components";
import { Button } from "../../components/Button.js";
import { Heading, SubHeading } from "./components/styles";
import { reCaptcha } from "../../config/variables";
import HubspotForm from "../../components/HubspotForm";

const Container = styled.section`
	padding: 63px 0 125px;

	@media screen and (max-width: 820px) {
		padding: 44px 20px 92px;
	}
`;

const FormContainer = styled.div`
	margin: 73px auto;
	max-width: 768px;

	@media screen and (max-width: 820px) {
		margin: 24px auto 20px;
	}
`;

const InputContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 24px;

	@media screen and (max-width: 500px) {
		grid-template-columns: 1fr;
	}
`;

const FormGroup = styled.div`
	margin: ${({ margin }) => margin || "0"};

	${({ last }) =>
		last &&
		css`
			grid-column: 1/-1;
		`}

	${({ terms }) =>
		terms &&
		css`
			display: flex;
			flex-direction: row;
			align-items: center;
		`}
`;

const Label = styled.label`
	font-weight: 500;
	font-size: 16px;
	line-height: 150%;
	color: #374151;
	display: block;

	${({ terms }) =>
		terms &&
		css`
			font-size: 14px;

			a {
				color: #0066cc;
				text-decoration: underline;
			}
		`}
`;

const baseInputStyle = css`
	width: 100%;
	border: 1px solid #e5e7eb;
	box-sizing: border-box;
	border-radius: 6px;
	background: white;
	margin-top: 8px;
	padding: 9.5px 8px;

	::placeholder {
		font-family: "Rubik";
		font-size: 16px;
		color: #6b7280;
	}
`;

const Input = styled.input`
	${baseInputStyle}

	${({ checkbox }) =>
		checkbox &&
		css`
			width: 18px;
			height: 18px;
			margin-right: 15px;
			margin-top: 0;
		`}
`;

const TextArea = styled.textarea`
	${baseInputStyle};
	height: 134px;
	padding: 8px;
`;

function Form() {
	return (
		<Container id="contact">
			<Heading center secondary>
				Contact <span>Us</span>
			</Heading>
			<SubHeading center margin="20px" subHeading>
				We'd love to explain how it works. <br />
				Submit the form with any questions & we'll be in touch in 24hrs.
			</SubHeading>
			<FormContainer
			>
				<HubspotForm />
			</FormContainer>
		</Container>
	);
}

export default Form;
